import $http from "@/api/index";

/**
 * 根据科室ID获取当前科室下的所有在用的人员
 * @param {*} deptID 科室ID
 * @param {*} userType 查询的类型 0 默认科室下所有 1 科室主负责人 2 科室副负责人
 */
export function GetDeptUser(deptID, userType = 0) {
  const getUrl = {
    method: "GET",
    url: "User/GetDeptUser",
    requestType: 2
  };
  const para = {
    deptID,
    userType
  };
  return $http(getUrl, para);
}
